import classNames from 'classnames'
import { AnchorHTMLAttributes, ComponentProps, forwardRef } from 'react'
import { Typography } from '../Typography'
import { anchor } from './Anchor.css'
import { sprinkles, Sprinkles } from '../../theme/sprinkles.css'
import { UrlObject } from 'url'

interface LinkProps {
	href?: string | UrlObject
}

type Props = Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'rel'> &
	Omit<ComponentProps<typeof Typography>, 'component'> &
	LinkProps

export const Anchor = forwardRef<HTMLAnchorElement, Props>(
	({ children, textDecoration, color, lineHeight = 'md', ...props }, ref) => {
		const sprinklesProps: Sprinkles = {
			textDecoration: textDecoration || { default: 'none', hover: 'underline' },
			color: color || { default: 'common.black' },
			lineHeight
		}

		return (
			<Typography ref={ref} component={'a'} className={classNames(sprinkles(sprinklesProps), anchor)} {...props}>
				{children}
			</Typography>
		)
	}
)
